window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperbombaProvjeraRepo = function () {

    var get = function (sifra) {
        return fetch('api/casinosuperbombaprovjera?sifra=' + sifra, {credentials: repos.base.credentials})
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }
}();